// Lightweight SEO counts and representative sitemap snippets.
// Keep this file data-only so route metadata does not pull full UI databases into every route chunk.

export const PAL_COUNT = 192;
export const GUIDE_COUNT = 417;
export const OFFICIAL_CARD_COUNT = 244;

export const PAL_SCHEMA_SAMPLE = [
  { name: "Lamball", slug: "lamball" },
  { name: "Cattiva", slug: "cattiva" },
  { name: "Chikipi", slug: "chikipi" },
  { name: "Lifmunk", slug: "lifmunk" },
  { name: "Foxparks", slug: "foxparks" },
  { name: "Fuack", slug: "fuack" },
  { name: "Sparkit", slug: "sparkit" },
  { name: "Tanzee", slug: "tanzee" },
  { name: "Rooby", slug: "rooby" },
  { name: "Pengullet", slug: "pengullet" },
  { name: "Penking", slug: "penking" },
  { name: "Jolthog", slug: "jolthog" },
  { name: "Gumoss", slug: "gumoss" },
  { name: "Vixy", slug: "vixy" },
  { name: "Hoocrates", slug: "hoocrates" },
  { name: "Teafant", slug: "teafant" },
  { name: "Depresso", slug: "depresso" },
  { name: "Daedream", slug: "daedream" },
  { name: "Rushoar", slug: "rushoar" },
  { name: "Nox", slug: "nox" },
] as const;

export const GUIDE_SCHEMA_SAMPLE = [
  { title: "Palworld Starter Guide", slug: "starter" },
  { title: "Palworld Breeding Guide", slug: "palworld-breeding-guide" },
  { title: "Best Flying & Ground Mounts", slug: "best-mounts" },
  { title: "Meta Tier List", slug: "tier-list" },
  { title: "Palworld TCG Gameplay Rules", slug: "palworld-tcg-gameplay-rules" },
  { title: "Palworld Cake Guide", slug: "palworld-cake-guide" },
  { title: "Card Grading: PSA & Beckett", slug: "palworld-card-grading-services" },
  { title: "Eternal Ascent Trial Decks", slug: "palworld-eternal-ascent-trial-decks" },
  { title: "Palworld News 2026", slug: "palworld-news-2026" },
  { title: "All Eggs Guide & FAQ", slug: "palworld-all-eggs-guide" },
] as const;
